import { render, staticRenderFns } from "./PressRelease-05-03-2022.vue?vue&type=template&id=9cfd48dc&scoped=true"
import script from "./PressRelease-05-03-2022.vue?vue&type=script&lang=js"
export * from "./PressRelease-05-03-2022.vue?vue&type=script&lang=js"
import style0 from "./PressRelease-05-03-2022.vue?vue&type=style&index=0&id=9cfd48dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfd48dc",
  null
  
)

export default component.exports